import React from 'react';
import About from '../components/Home/About';
import Header from '../components/Header';
import Footer from '../components/Footer';

const AboutPage = () => {
  return (
    <div>
        <Header />
        <div style={{ marginTop: '80px' }}>
            <About />
        </div>
        <Footer />
    </div>
  );
};

export default AboutPage;
